<template>
  <div class="sidebar" :data="backgroundColor">
    <div ref="sidebarScrollArea" class="sidebar-wrapper">
      <div class="logo">
        <a href="https://www.storylabs.dev" class="simple-text logo-mini">
          <img :src="logo()" alt="app-logo" />
        </a>
        <a href="https://www.storylabs.dev" class="simple-text logo-normal">
          {{ title }}
        </a>
      </div>
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink"> </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Sidebar',
  props: {
    title: {
      type: String,
      default: 'JIT.cr',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'CT',
      description: 'Sidebar short title'
    },
    // logo: {
    //   type: String,
    //   default: '',
    //   description: 'Sidebar app logo'
    // },
    backgroundColor: {
      type: String,
      default: 'vue',
      validator: value => {
        const acceptedValues = ['', 'vue', 'blue', 'green', 'orange', 'red', 'primary']
        return acceptedValues.indexOf(value) !== -1
      },
      description: 'Sidebar background color (vue|blue|green|orange|red|primary)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description: "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  },
  methods: {
    logo() {
      const deflogo = 'https://raw.githubusercontent.com/cachac/webAssets/main/logos/jit-basic.png'

      return this.$store.state.facturacion.emisorStore.emisor.img || deflogo
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize()
      }
    }
  }
}
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

.logo-main {
  background-color: red !important;
  border-radius: 0% !important;
}
</style>
